module.exports = __webpack_public_path__ + "img/icon-cpg.d3663b66.svg";